<template>
  <div class="w-full flex flex-col bg-white rounded-r-lg">
    <div class="p-3 sm:p-6 !pb-0">
      <div class="text-2xl sm:text-3xl font-bold mb-2">
        Review services{{ hasSelectedPackage ? `: ${selectedPackage.name}` : "" }}
      </div>
    </div>
    <div class="flex-1 overflow-y-auto p-3 sm:p-6">
      <div class="space-y-4">
        <template v-for="(section, key) in sections">
          <template v-if="isDepositFrequency(section)">
            <portal-billing-service-item-card
              :is-deposit="true"
              :section="section"
              :selected-add-ons="selectedAddOns"
              @set-selected-add-ons="$emit('set-selected-add-ons', $event)"
            />
            <portal-billing-service-item-card
              :is-balance="true"
              :section="section"
              :selected-add-ons="selectedAddOns"
              @set-selected-add-ons="$emit('set-selected-add-ons', $event)"
            />
          </template>
          <template v-else>
            <portal-billing-service-item-card
              :section="section"
              :selected-add-ons="selectedAddOns"
              @set-selected-add-ons="$emit('set-selected-add-ons', $event)"
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import PortalBillingServiceItemCard from "./PortalBillingServiceItemCard.vue"

export default {
  name: "PortalBillingProposalServices",
  components: { PortalBillingServiceItemCard },
  emits: ["set-selected-add-ons"],
  props: {
    selectedAddOns: {
      type: Array,
      default: () => [],
    },
    selectedPackage: {
      type: Object,
    },
  },

  data() {
    return {
      proposal: window.FinancialCents.proposal,
    }
  },

  computed: {
    hasSelectedPackage() {
      return this.selectedPackage !== null
    },
    sections() {
      return this.hasSelectedPackage ? this.selectedPackage.sections : this.proposal.packages[0].sections
    },
  },
  methods: {
    isDepositFrequency(section) {
      return section.frequency === "deposit"
    },
  },
}
</script>
